import { createIndicator } from "@nexus/widget-kit";

/**
 * Piracy audience indicator: the shared metric indicator on the `piracy-audience-metrics` source only, so an
 * author picks a metric of this domain and never a source.
 */
const indicator = createIndicator({
  id: "piracy-audience-indicator",
  name: "Piracy audience indicator",
  description:
    "Up to three figures of the piracy audience report, such as viewers disrupted, with their trend.",
  source: "piracy-audience-metrics",
  sources: ["piracy-audience-metrics"],
  figures: 3,
});

export const { manifest, Component, defaultConfig, settings } = indicator;
export default indicator;
